import type { ReactNode } from 'react'

export function Field({ label, required, hint, children, span }: { label: ReactNode; required?: boolean; hint?: ReactNode; children: ReactNode; span?: 1 | 2 }) {
  return (
    <label className={`field${span === 2 ? ' field--full' : ''}`}>
      <span className="field-label label">{label}{required && <span className="field-req">*</span>}</span>
      {children}
      {hint && <span className="field-hint dim">{hint}</span>}
    </label>
  )
}

export function TextInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className="input" {...props} />
}
export function TextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className="input input--area" {...props} />
}
export function Select({ children, ...props }: React.SelectHTMLAttributes<HTMLSelectElement> & { children: ReactNode }) {
  return <select className="input input--select" {...props}>{children}</select>
}

export function FormGrid({ children }: { children: ReactNode }) {
  return <div className="form-grid">{children}</div>
}
